<div class="chip-indicator" [ngClass]="[color, size]">
    <ng-content></ng-content>
</div>
  
